export default __webpack_public_path__ + "static/media/redd.a6f9e002.gif";